let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8l0EI")).then(() => parcelRequire('eFn1C'));